import {Component, Input, OnDestroy} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AuthService} from '../../../services/auth.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastService} from '../../toast/toast.service';
import {finalize, Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'app-password-reset-modal',
  imports: [
    FormsModule
  ],
  templateUrl: './password-reset-modal.component.html',
  styleUrl: './password-reset-modal.component.scss'
})
export class PasswordResetModalComponent implements OnDestroy {
  onDestroy$ = new Subject<boolean>();

  @Input() email = "";

  submitted = false;

  constructor(private modal: NgbActiveModal,
              private toast: ToastService,
              private authService: AuthService) {
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  submit() {
    if (!this.email) {
      return
    }

    this.submitted = true;
    this.authService.resetPassword(this.email).pipe(
      takeUntil(this.onDestroy$),
      finalize(() => this.submitted = false))
      .subscribe(() => {
        this.toast.success("Your new password has been sent! Please check your email")
        this.close()
      })
  }

  close() {
    this.modal.close()
  }

}
